var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 6.6665H6.66659C5.93325 6.6665 5.33992 7.2665 5.33992 7.99984L5.33325 15.9998C5.33325 16.7332 5.93325 17.3332 6.66659 17.3332H17.3333C18.0666 17.3332 18.6666 16.7332 18.6666 15.9998V7.99984C18.6666 7.2665 18.0666 6.6665 17.3333 6.6665ZM17.3333 9.33317L11.9999 12.6665L6.66659 9.33317V7.99984L11.9999 11.3332L17.3333 7.99984V9.33317Z",
    fill: "#9BA9B0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon2);
export default __webpack_public_path__ + "static/media/emailIcon2.b8f91ad0737ab3be510b27cfb6097bee.svg";
export { ForwardRef as ReactComponent };